import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./HelpText.module.css";
// import classNames from "classnames";

export const HelpText = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.HelpText}>
      <p>{t("login.helpText")}</p>
      <a href="https://www.google.ru/intl/ru/chrome/" target="_blank">
        {t("login.downloadChrome")}
      </a>
    </div>
  );
};
